import Vue from 'vue';
import VueCompositionApi, {computed, onMounted, onUnmounted, reactive, ref, Ref} from '@vue/composition-api'
import axios from 'axios';

Vue.use(VueCompositionApi);

//closest polyfill
const ElementPrototype = window.Element.prototype;
if (typeof ElementPrototype.matches !== 'function') {
  ElementPrototype.matches = ElementPrototype.msMatchesSelector || ElementPrototype.mozMatchesSelector || ElementPrototype.webkitMatchesSelector ||
    function matches(selector) {
      let element = this;
      const elements = (element.document || element.ownerDocument).querySelectorAll(selector);
      let index = 0;
      while (elements[index] && elements[index] !== element) ++index;

      return Boolean(elements[index]);
    };
}
if (typeof ElementPrototype.closest !== 'function') {
  ElementPrototype.closest = function closest(selector) {
    let element = this;

    while (element && element.nodeType === 1) {
      if (element.matches(selector)) return element;
      element = element.parentNode;
    }

    return null;
  };
}


//strings
export function nl2br(s) {return s.replace(/\n/g, '<br/>');}
export function nl2br2(s) {return s.replace(/\n/g, '<br/><br/>');}
export function nl2p(s) {return '<p>' + s.replace(/\n/g, '</p><p>') + '</p>';}
export function bgi(s) {return {'background-image': 'url('+s+')'}}
export function isIE() {return /Edge\/|Trident\/|MSIE /.test(window.navigator.userAgent);}

//url
export function urlSegment(num) {return location.pathname.split('/')[num]}
export function urlSegmentNum(num,max,min) {
  if (min === undefined) min = 1;
  let val = Number(urlSegment(num));
  if (!val || val < min || (max !== undefined && val > max)) val = min;
  return val;
}

//convert
export function obj2arr(obj) {
  const arr = [];
  for (const objKey in obj) {arr.push(obj[objKey])}
  return arr;
}
export function arr2obj(arr,value=false) {
  const obj = {};
  for (const item in arr) {obj[arr[item]]=value}
  return obj;
}
export function remToPixels(rem) {
  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}
export function pixelsToRem(px) {
  const fontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
  return Number((parseInt(px) / fontSize).toFixed(1));
}
export const objLength = (obj) => Object.keys(obj).length;

//some utils
export function gGoal(goal,add='') {
  if (!goal) return;
  if (typeof window['ga'] == 'function') {
    if (add) ga('send', 'event', goal, add);
    else ga('send', 'event', goal);
  }
  else console.log('no analitics');
  console.log('goal --> ',goal, add);
}
export function gPage(name) {
  if (window.ga) ga('send', 'pageview',`${name}`);
  console.log('page --> ',name);
}
export function scrollToBlock(obj,options) {
  const opts = {parent: window, time: 300, add: 0, ...options};
  if (typeof obj === 'string') obj = document.querySelector(obj);
  const parent = opts.parent
    ? (typeof opts.parent === 'string') ? document.querySelector(opts.parent) : opts.parent
    : window;
  const top = parent === window ? window.pageYOffset : parent.scrollTop;
  let coordY = obj.getBoundingClientRect().top;
  let destCoord = top + coordY + opts.add;
  let scrollBy = coordY / (opts.time / 10);

  window.inScroller = true;
  let scroller = setInterval(function() {
    const top = parent === window ? window.pageYOffset : parent.scrollTop;
    const height = parent === window ? window.innerHeight : parent.offsetHeight;
    const max = parent === window ? document.body.offsetHeight : parent.scrollHeight;
    let go = scrollBy > 0
      ? top + scrollBy < destCoord && top + height + 1 < max
      : top + scrollBy > destCoord && top > 0;

    if (go) parent.scrollBy(0, scrollBy);
    else {
      parent.scrollTo(0, destCoord);
      clearInterval(scroller);
      window.inScroller = false;
    }
  }, 10);
}
export function randomInteger(min, max) {
  let rand = min - 0.5 + Math.random() * (max - min + 1);
  rand = Math.round(rand);
  return rand;
}
export const useAddEvent = (name, func, obj = window) => {
  onMounted(() => obj.addEventListener(name,func));
  onUnmounted(() => obj.removeEventListener(name,func));
};


export function readFilefromInput(input) {
  if (!input.files.length) return '';
  const file = input.files[0];

  return new Promise((resolve, reject) => {
    let reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result);
    };

    reader.onerror = reject;

    reader.readAsDataURL(file);
  })
}
export function readFileAsync(file) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result);
    };

    reader.onerror = reject;

    reader.readAsDataURL(file);
  })
}

export function readTextAsync(file) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result);
    };

    reader.onerror = reject;

    reader.readAsText(file);
  })
}



//appear & appear anim
export const appearance = (arr,func,desktop=true,mobile=true) => {
  if (!(inMobile ? mobile : desktop)) return;
  const winHeight = document.documentElement.clientHeight;
  const elems = typeof arr === 'string' ? document.querySelectorAll(arr) : arr;
  for (let i = 0; i < elems.length; i++) {
    const element = elems[i];
    const elTop = element.getBoundingClientRect().top;
    const elHeight = element.offsetHeight;
    const top = winHeight - elTop;
    const bottom = elTop + elHeight;

    const appear = top > 0 && bottom > 0;

    if (Array.isArray(func)) func[Number(!appear)](appear, element, i);
    else if (appear) func(appear, element, i)
  }
};
let inAppear = false;
export function addAppear(arr,func,desktop=true,mobile=true) {
  let timer;
  window.addEventListener('scroll', () => {
    clearTimeout(timer);
    timer = setTimeout(() => {appearance(arr,func,desktop,mobile)}, 100);
  });
}

const setAnim = (on,el,repeat) => {
  if (on) {
    el.classList.add('animated');
    el.classList.remove('wow2');
    if (repeat) el.classList.add('wow1');
  }
  else {
    el.classList.remove('animated');
    el.classList.remove('wow1');
    if (repeat) el.classList.add('wow2');
  }
};
export const startAnim = (repeat=false, desktop=true, mobile=true) => {
  if (!(inMobile ? mobile : desktop)) return;

  const elems = document.querySelectorAll('.wow1, .wow2');
  for (let i = 0; i < elems.length; i++) {
    const el = elems[i];
    setAnim(false,el,true);
    setTimeout(() =>{setAnim(true,el,repeat);},50);
  }
};
export const initAnim = (repeat=false, desktop=true, mobile=true) => {
  const anim = (appear,el,index) => {setAnim(appear,el,repeat)};
  addAppear('.wow2, .wow1', [anim,anim], desktop,mobile);
  appearance('.wow2, .wow1', [anim,anim], desktop,mobile)
};

//absolute opition to style
export const pos2Style = (data, k = 1) => {
  let parseData = {
    l: 'left', r: 'right',
    t: 'top', b: 'bottom',
    w: 'width', h: 'height',
  };
  let res = {};

  for (let key in data) {
    let value = data[key];
    let name = parseData[key];
    if (name !== undefined) res[name] = value/10*k + 'rem'
  }
  if (data.z !== undefined) res['z-index'] = data.z;
  if (data.rt !== undefined) res['transform'] = `rotate(${data.rt}deg)`;
  if (data.s !== undefined)
    if (!res['transform']) res['transform'] = `scale(${data.s})`;
    else res['transform'] += ` scale(${data.s})`;
  //console.log(res);
  return res;
};

// vue
export const mobile_mixin = {
  data: function() {return {inMobile: inMobile,}},
  created() {window.addEventListener('resize',this.updateMobile);},
  methods: {updateMobile() {this.inMobile = inMobile;}}
};

export const useMobile = () => {
  const inMobile = ref(window.inMobile);
  onMounted(() => {
    window.addEventListener('resize',() => {
      inMobile.value = window.inMobile;
    });
  });

  return {inMobile}
}


export const refArray = (count,val = 0) => {
  const res = [];
  for (let i = 0; i < count; i++) {
    const v = typeof(val) === 'function' ? val(i) : val;
    res.push(ref(v));
  }
  return res;
};
export const refArray2Array = (arr) => {
  const res = [];
  for (let i = 0; i < arr.length; i++) res.push(arr[i].value);
  return res;
};
export const refObj2Obj = (obj) => {
  const res = {};
  for (const key in obj) res[key] = obj[key].value;
  return res;
};
export const toggleRef = r => {r.value = !r.value};
export const incRef = (r,inc = 1) => {r.value = r.value + inc};
export const rotateRef = (r, inc, max, start=0) => {
  //console.log(r.value,inc,max);
  let val = r.value + inc;
  if (val < start) val = max;
  else if (val > max) val = start;
  r.value = val;
}
export const rotateVal = (r, valName, inc, max, start=0) => {
  //console.log(r.value,inc,max);
  let val = r[valName] + inc;
  if (val < start) val = max;
  else if (val > max) val = start;
  r[valName] = val;
}

let inWheelRotate = false;
export const wheelRotate = (e, r, max, timeout=300) => {
  if (inWheelRotate) return;
  inWheelRotate = true;
  setTimeout(() => {inWheelRotate = false},300);
  rotateRef(r,e.deltaY > 0 ? 1 : -1, max)
}

// vue module routines
export const useScrollInParent = (elem, disable=false, center=false) => {
  const startScroll = ref(0);
  const left = ref(0);

  /*
  * 0 - top
  * 1 - fixed
  * 2 - bottom
  * */
  const stage =ref(0);
  const style = computed(() => {
    const res = {};
    switch (stage.value) {
      case 1: res.top = 0; break;
      case 2:
        res.position = 'fixed';
        res.top = startScroll.value+'px';
        res.left = left.value+'px';
        break;
      case 3: res.bottom = 0; res.top = 'auto'; break;
    }
    return res;
  });

  onMounted(() =>{window.addEventListener('scroll', scrollElement)});
  onUnmounted(() =>{window.removeEventListener('scroll', scrollElement)});

  let inScroll = false;
  const scrollElement = (e) => {
    const doScroll = () => {
      let el = elem.value;
      if (el instanceof Vue) el = el.$el;
      if (stage.value === 0) left.value = el.getBoundingClientRect().left;
      const elHeight = el.offsetHeight;
      const winHeight = document.documentElement.clientHeight;

      const parent = el.parentNode;
      const parentHeight = parent.offsetHeight;
      const top = parent.getBoundingClientRect().top;
      const maxTop = parentHeight - elHeight;
      startScroll.value = center ? (winHeight- elHeight) / 2 : 0;

      const inView = top < winHeight && top + parentHeight > 0;
      if (inView) {
        if (top > startScroll.value) stage.value = 0;
        else
          if (top - startScroll.value > -maxTop) {
          stage.value = 2;
        }
        else stage.value = 3;
      }
    };

    if (!inScroll) {
      if (disable) return;
      inScroll = true;
      window.requestAnimationFrame(() => {
        doScroll();
        inScroll = false;
      });
    }
  };

  return {style}
};

export const calcMaxRef = arr => {
  let max = 0; let num = 0;
  for(let i = 0; i < arr.length; i++) {
    if (!arr[i]) continue;
    let cur = arr[i].value;
    if (cur > max) {max = cur;num = i;}
  }
  return {max, num}
};

export const calcMaxResult = (arr, ignore = -1) => {
  const res = [];
  for(let i = 0; i < arr.length; i++) {
    const val = arr[i].value;
    if (val === ignore) continue;
    if (res[val]) incRef(res[val]);
    else res[val] = ref(1);
  }
  return calcMaxRef(res);
};

//test
export const useTest = (questions, routines, options = {}) => {
  /*routines
  *
  * onSelectAnswer
  * onNextQuestion
  * onTestEnd
  * getRightAnswer
  * getAnswerValue
  * */

  const data = reactive({
    testStage: 0,
    questions: questions,
    count: questions.length,
    number: 0,
    current: computed(() => (questions[data.number])),
    isLast: computed(() => (data.number === data.count - 1)),
    testEnded: false,

    lastAnswer: 0,
    lastRight: false,

    results: refArray(questions.length),
    sumResults : [],
    resultBalls: 0,
    resultWrong: 0,

    inComment: false
  });

  const opts = reactive({
    goalStart: '',
    goalEnd: '',
    goalQuestion: '',
    useComment: false,
    ...options
  });

  const sendGoal = goal => {
    if (goal) gGoal(goal);
  };

  const rightAnswer = index => !routines.getRightAnswer ? !index : routines.getRightAnswer(data, index);
  const answerValue = index => !routines.getAnswerValue ? index : routines.getAnswerValue(data, index);

  const selectAnswer = index => {
    //statistics
    if (data.number === 0) sendGoal(opts.goalStart);

    //save result
    const value = answerValue(index);
    data.results[data.number].value = value;

    if (value > 0) {
      if (data.sumResults[value]) incRef(data.sumResults[value]);
      else Vue.set(data.sumResults,value,ref(1));
    }

    data.lastAnswer = index;
    data.lastRight = rightAnswer(index);
    if (data.lastRight) data.resultBalls++;
    else data.resultWrong++;

    if (routines.onSelectAnswer) routines.onSelectAnswer(data, methods);
    if (opts.goalQuestion) sendGoal(opts.goalQuestion+(data.number+1));
    if (!opts.useComment) nextQuestion(); else data.inComment = true;
  };

  const nextQuestion = () => {
    data.inComment = false;
    //check end
    if (data.isLast) testEnd(); else data.number++;
    if (routines.onNextQuestion) routines.onNextQuestion(data, methods);
  };

  const testStart = () => {
    data.testStage = 1;
    sendGoal(opts.goalStart);
  }
  const testEnd = () => {
    sendGoal(opts.goalEnd);
    if (routines.onTestEnd) routines.onTestEnd(data, methods);
    data.testEnded = true;
    data.testStage = 2;
  };

  const reset = () => {
    data.testEnded = false;
    data.testStage = 1;
    data.number = data.resultBalls = data.resultWrong = 0;
    data.results.forEach((v,i,arr) => {arr[i].value = 0});
  };

  const methods = {
    selectAnswer,
    nextQuestion,
    testStart,
    testEnd,
    reset
  };

  return {
    data, methods
  }

};
//drag
export const useDrag = (el, options={}) => {
  //fStart=null, fMove=null, fUp=null,
  // eventsOnContainer=false, disableDrag=false, notUseMounted=false
  //onlyInParent=false
  const mousePos = reactive({x:0, y:0});
  const mouseStart = reactive({x:0, y:0});
  const mouseDelta = reactive({x:0, y:0});
  const startPos = reactive({x:0, y:0});
  const parentPos = ref(null);


  const addListenerMulti = (el, s, fn) => s.split(' ').forEach((e) => el.addEventListener(e, fn));
  const removeListenerMulti = (el, s, fn) => s.split(' ').forEach((e) => el.removeEventListener(e, fn));

  let body = options.eventsOnContainer ? el.value : document;

  const getTouchPos = (e) => {
    let d = e.type === 'mousedown' || e.type === 'mousemove' || e.type === 'mouseup' ? e : e.changedTouches[0];
    mousePos.x = d.pageX;
    mousePos.y = d.pageY;
    mouseDelta.x = mousePos.x - mouseStart.x;
    mouseDelta.y = mousePos.y - mouseStart.y;
    //console.log(mouseStart.x, mousePos.x);
  };

  //move
  const onMove = (e) => {
    //console.log('move');
    //e.preventDefault();
    getTouchPos(e);
    if (options.fMove && options.fMove(e,mouseData)) onUp(e);
    if (options.onlyInParent) {
      const pp = parentPos.value;
      const mp = {x: mousePos.x - window.pageXOffset,
        y:mousePos.y - window.pageYOffset};
      if (mp.x < pp.left ||mp.x > pp.right ||
        mp.y < pp.top ||mp.y > pp.bottom) onUp(e);
    }
  };

  //up
  const onUp = (e) => {
    //console.log('up');
    removeListenerMulti(body, "mousemove touchmove", onMove);
    removeListenerMulti(body, "mouseup touchend", onUp);
    getTouchPos(e);
    if (options.fUp) options.fUp(e,mouseData);
  };

  const resetStart = (e) => {
    getTouchPos(e);
    mouseStart.x = mousePos.x;
    mouseStart.y = mousePos.y;

    const style = getComputedStyle(el.value);
    startPos.x = parseInt(style.left);
    startPos.y = parseInt(style.top);
  }

  const mouseData = {mousePos,mouseStart,mouseDelta,startPos,el, resetStart};

  const dragEvents = (e) => {
    if (options.disableDrag) return;
    resetStart(e);

    parentPos.value = el.value.parentNode.getBoundingClientRect();

    if (options.fStart && options.fStart(e,mouseData)) return;

    addListenerMulti(body, "mousemove touchmove", onMove);
    addListenerMulti(body, "mouseup touchend", onUp);

    if (!options.noPrevent) e.preventDefault();
    //e.stopPropagation();

    //console.log('start');

  };

  const initStart = () => {
    addListenerMulti(el.value, 'mousedown touchstart', dragEvents);
    addListenerMulti(el.value, "dragstart", (e) => {e.preventDefault()});
  };

  if (!options.notUseMounted) {
    onMounted(() =>{initStart()});
  } else initStart();

  if (!options.notUseMounted)
    onUnmounted(() => {removeListenerMulti(body, 'mousedown touchstart', dragEvents);});
};
//swipe
export const useSwipe = (el, swipeFunc, persent= 10) => {
  const size = Math.min(window.innerHeight,window.innerWidth) / 100 * persent;

  const fUp = (e,{mouseDelta}) => {
    const absX = Math.abs(mouseDelta.x);
    const absY = Math.abs(mouseDelta.y);
    if (absX < size && absY < size) return;

    const vertical = absY > absX;
    let res = vertical
      ? (mouseDelta.y > 0 ? 'down' : 'up')
      : (mouseDelta.x > 0 ? 'right' : 'left');

    swipeFunc(res);
  };

  useDrag(el,{fUp: fUp, notUseMounted: true, noPrevent: true});
};

//axios
export const axiosServer = ref('/');
export const post = (address, data, func) => {
  axios.post(axiosServer.value+address, data).then((r) => {if (func) func(r.data)});
};

//local
export const localName = ref('');
export const local = computed(() => location.hostname === localName.value);

//add modules
export const computedRefs = (refs,name) =>
  computed({get: () => refs[name], set: (val => {})});

export const usePreloader = (preloader=null) => {
  if (preloader===null) preloader = ref(null);
  const loaded = computed({
    get: () => preloader.value?.loaded.value,
    set: (val) => {preloader.value.loaded.value = val}
  });
  return {preloader: preloader, loaded}
}
export const usePages = (pages=null) => {
  if (pages===null) pages = ref(null);
  const curPage = computed({
    get: () => pages.value?.curPage,
    set: (val) => {pages.value?.setPage(val);}
  });

  return {pages, curPage}
}
export const usePopups = (popups=null) => {
  if (popups===null) popups = ref(null);
  const openPopup = (name) => {popups.value?.openPopup(name)};
  const popupOpened = (name) => popups.value?.isOpened(name);
  const closePopup = (name) => {popups.value?.closePopup(name)};
  const topPopup = computed(() => popups.value.topPopup);

  return {popups, openPopup, popupOpened, closePopup, topPopup}
}
export const useAuth = () => {
  const getHashCode = (f=null) => {
    post('get_hashcode', {}, (c) => {
      auth.hashCode = c.hashcode;
      if (c.hashcode !== '') auth.isAuth = true;
      if (f) f();
      //console.log(c, hashCode.value);
    });
  }

  const auth = reactive({
    isAuth: false,
    hashCode: '',
    getHashCode
  })

  return auth;
}

export const useMenu = (menu=null) => {
  if (menu===null) menu = ref(null);
  const menuOpened = computed({
    get: () => menu.value.menuOpened,
    set: (val) => {menu.value.menuOpened = val;}
  });

  return {menu, menuOpened}
}
